import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/auth/Login';
import Dashboard from './pages/Dashboard';
import Profile from './pages/auth/Profile';
import Users from './pages/Users';
import Subscriptions from './pages/Subscriptions';
import Support from './pages/Support';
import Packages from './pages/Packages';
import Settings from './pages/Settings';
import UserSearchResults from './pages/UserSearchResults';
import MessageTemplates from './pages/MessageTemplates';
import EmailBroadcast from './pages/EmailBroadcast';
import CronJobs from './pages/CronJobs';
import EmailLogs from './pages/EmailLogs';
import FreeSubscriptions from './pages/FreeSubscriptions';
import AppVersions from './pages/AppVersions';
import AdminLayout from './components/layout/AdminLayout';
import ProtectedRoute from './components/ProtectedRoute';
import { NotificationProvider } from './context/NotificationContext';

function App() {
  return (
    <BrowserRouter>
      <NotificationProvider>
      <Routes>
        <Route path="/login" element={<Login />} />
        
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <AdminLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="profile" element={<Profile />} />
          <Route path="users" element={<Users />} />
          <Route path="subscriptions" element={<Subscriptions />} />
          <Route path="user-search-results" element={<UserSearchResults />} />
          <Route path="support" element={<Support />} />
          <Route path="packages" element={<Packages />} />
          <Route path="settings" element={<Settings />} />
          <Route path="message-templates" element={<MessageTemplates />} />
          <Route path="email-broadcast" element={<EmailBroadcast />} />
          <Route path="cron-jobs" element={<CronJobs />} />
          <Route path="email-logs" element={<EmailLogs />} />
          <Route path="free-subscriptions" element={<FreeSubscriptions />} />
          <Route path="app-versions" element={<AppVersions />} />
        </Route>

        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
      </NotificationProvider>
    </BrowserRouter>
  );
}

export default App;